import { ShieldCheck, CalendarCheck, FileSpreadsheet, Zap, Globe2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { WA_NUMBER } from "@/lib/api";

const PILGRIMS_IMG =
  "https://images.unsplash.com/photo-1572358899655-f63ece97bfa5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxtYXNqaWQlMjBuYWJhd2klMjBtYWRpbmFoJTIwcmF3ZGFoJTIwdW1yYWh8ZW58MHx8fHwxNzkwOTI1OTYwfDA&ixlib=rb-4.1.0&q=85";

const cardClass =
  "group relative rounded-2xl bg-[#0F172A] border border-white/8 p-6 sm:p-8 overflow-hidden transition-all duration-300 hover:border-sky-400/40 hover:-translate-y-1";

export const Features = () => (
  <section id="keunggulan" className="relative py-20 lg:py-28" data-testid="features-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-sky-400" data-testid="features-eyebrow">
          Keunggulan Kami
        </p>
        <h2 className="mt-4 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-white max-w-2xl" data-testid="features-title">
          Kenapa Travel Umroh Mempercayakan Permit Rawdah kepada Kami
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
        <Reveal className="md:col-span-7" delay={0.05}>
          <div className={`${cardClass} h-full min-h-[320px] flex flex-col justify-end`} data-testid="feature-aman-card">
            <img
              src={PILGRIMS_IMG}
              alt="Suasana jamaah di pelataran Masjid Nabawi"
              className="absolute inset-0 w-full h-full object-cover opacity-40 transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-[#0A0F1D]/70 to-transparent" />
            <div className="relative">
              <ShieldCheck size={30} className="text-emerald-400" />
              <h3 className="mt-4 font-display font-semibold text-xl sm:text-2xl text-white">100% Aman — Data Visa Resmi</h3>
              <p className="mt-2 text-sm sm:text-base text-slate-300 leading-relaxed max-w-md">
                Permit dibooking langsung menggunakan data visa resmi jamaah Anda. Tanpa jalan pintas, tanpa risiko
                ditolak di gerbang Rawdah.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal className="md:col-span-5" delay={0.12}>
          <div className={`${cardClass} h-full`} data-testid="feature-slot-card">
            <CalendarCheck size={28} className="text-sky-400" />
            <h3 className="mt-4 font-display font-semibold text-xl text-white">Slot Terjadwal & Terpantau</h3>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
              Jadwal permit dipantau real-time mengikuti ketersediaan slot resmi, disesuaikan dengan itinerary travel Anda.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["05:00", "09:00", "14:00", "18:00", "20:00"].map((t) => (
                <span key={t} className="font-mono2 text-xs px-3 py-1.5 rounded-full border border-sky-400/30 text-sky-300">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal className="md:col-span-4" delay={0.05}>
          <div className={`${cardClass} h-full`} data-testid="feature-excel-card">
            <FileSpreadsheet size={28} className="text-emerald-400" />
            <h3 className="mt-4 font-display font-semibold text-lg text-white">Booking Massal via Excel</h3>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
              Satu file Excel untuk puluhan jamaah sekaligus. Nama, tanggal lahir, no passport, no visa — beres.
            </p>
          </div>
        </Reveal>

        <Reveal className="md:col-span-4" delay={0.12}>
          <div className={`${cardClass} h-full`} data-testid="feature-fast-card">
            <Zap size={28} className="text-amber-400" />
            <h3 className="mt-4 font-display font-semibold text-lg text-white">Fast Response ±15 Menit</h3>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
              Admin standby setiap hari. Hubungi langsung:
            </p>
            <p className="mt-3 font-mono2 text-lg font-semibold text-white" data-testid="feature-admin-number">
              {WA_NUMBER}
            </p>
          </div>
        </Reveal>

        <Reveal className="md:col-span-4" delay={0.19}>
          <div className={`${cardClass} h-full`} data-testid="feature-sea-card">
            <Globe2 size={28} className="text-sky-400" />
            <h3 className="mt-4 font-display font-semibold text-lg text-white">Dipercaya Asia Tenggara</h3>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
              Melayani travel umroh dari Indonesia, Malaysia, Singapura, Brunei Darussalam, dan Thailand Selatan.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
